"use client"

import { useEffect } from "react"
import { setEllaVisible } from "@/lib/chat/ella-embed"

/**
 * Rendered on countries without chat (`feature:chat` off) in place of the
 * launcher. The Ella loader lives on `window` and outlives the React tree, so
 * soft-navigating here from a chat country would otherwise leave its bubble
 * on this page, still carrying the old market. Hide it on mount; navigating
 * back to a chat country shows it again via `ensureEllaLoaded`.
 */
export function ChatHidden() {
  useEffect(() => {
    setEllaVisible(false)
  }, [])

  return null
}
